import apiClient from 'api/common/common'
import { Status } from 'api/common/statuses'

/**
 * 出金残高情報
 */
export interface WithdrawalBalance {
  totalReceivedAmount: number // 累計受け取り報酬額
  availableAmount: number // 出金申請可能額
}

/**
 * 有効期限間近の報酬
 */
export interface ExpiringReward {
  expiryDate: Date
  amount: number
}

/**
 * 銀行口座情報
 */
export interface BankAccount {
  bankName: string
  branchName: string
  accountType: string
  accountNumber: string
  accountName: string
}

/**
 * ポジション報酬ステータス
 */
export interface PositionRewardStatus {
  // ポジションラベル (e.g. "メインポジション", "サブポジション1")
  position_label: string
  // 日次報酬確定者かどうか
  isDailyRewardUser: boolean
}

/**
 * 出金情報レスポンス
 */
export interface WithdrawalResponse {
  balance: WithdrawalBalance
  expiringRewards: ExpiringReward[]
  bankAccount: BankAccount
  positions: PositionRewardStatus[]
}

/**
 * 出金情報取得API
 * @param callback
 */
export const getWithdrawalInfoAPI = async (callback: (response?: WithdrawalResponse, status?: Status) => void) => {
  try {
    const response = await apiClient.get<WithdrawalResponse>('/withdrawalRequest/info')
    const status = response?.headers['x-aqc-status'] ?? Status.InternalError
    callback(response.data, status)
  } catch (error) {
    callback(undefined, Status.InternalError)
  }
}

/**
 * 出金申請API
 * @param amount
 * @param callback
 */
export const submitWithdrawalRequestAPI = async (amount: number, callback: (status?: Status) => void) => {
  try {
    const response = await apiClient.post('/withdrawalRequest/apply', { amount })
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    callback(status)
  } catch (error) {
    callback(Status.InternalError)
  }
}

/**
 * 出金ステータス
 */
export enum WithdrawalStatus {
  InProgress = 'in_progress',
  RequestAccepted = 'request_accepted',
  Paused = 'paused',
}

/**
 * 出金ステータスラベルマッピング
 */
export const WITHDRAWAL_STATUS_LABELS: { [key in WithdrawalStatus]: string } = {
  [WithdrawalStatus.InProgress]: '申請中',
  [WithdrawalStatus.RequestAccepted]: '振込処理済み',
  [WithdrawalStatus.Paused]: '保留',
}

/**
 * 出金履歴レコード
 */
export interface WithdrawalHistoryRecord {
  requested_at: Date | null
  request_accepted_at: Date | null
  withdrawal_amount: number
  status: WithdrawalStatus
}

/**
 * 出金履歴レスポンス
 */
export interface WithdrawalHistoryResponse {
  records: WithdrawalHistoryRecord[]
}

/**
 * 出金履歴取得API
 * @param callback
 */
export const getWithdrawalHistoryAPI = async (callback: (response?: WithdrawalHistoryResponse, status?: Status) => void) => {
  try {
    const response = await apiClient.get<WithdrawalHistoryResponse>('/withdrawalRequest/history')
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    callback(response.data, status)
  } catch (error) {
    callback(undefined, Status.InternalError)
  }
}
